var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({staticClass:"d-inline-block"},'div',_vm.$attrs,false),_vm.$listeners),[_c('img',{style:(("width: 180px;\n      height: " + _vm.height + "px;\n      object-fit: contain;")),attrs:{"src":_vm.logo}})])}
var staticRenderFns = []

export { render, staticRenderFns }